import { IBlueprint, IBlueprintEntry } from '@root/query'

export const calculateDebetCreditDifferenceFromBlueprint = (blueprint: IBlueprint): number => {
  const totalDebet = calculateEntriesTotal(blueprint?.debet_entries)
  const totalCredit = calculateEntriesTotal(blueprint?.credit_entries)

  return Math.abs(totalDebet - totalCredit)
}

export const calculateEntriesTotal = (entries: IBlueprintEntry[] = []) => {
  return entries.reduce((total, entry) => total + entry.amount, 0)
}
